import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Modules Material utilises
import { MatMenuModule } from '@angular/material/menu';

// Autres modules externes utilises 

// Modules communs utilises
import { ContextModule } from '../../technical-modules/context/context.module';
import { EventsModule } from '../../technical-modules/events/event-bus.module';

// Composants metiers
import { AccountMenuComponent } from './component/account-menu.component';

// Services metier
import { UserModule } from '../../data-domains/humain/user/user.module';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		
		MatMenuModule,
		
		ContextModule,
		EventsModule,
		
		UserModule,
	],
	providers: [
	],
	declarations: [
		AccountMenuComponent,
	],
	exports: [
	]
})
export class AccountMenuModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('accountMenu',
		downgradeComponent({ component: AccountMenuComponent })
	) //
;